module.exports = __webpack_public_path__ + "static/img/22.d08a47b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/22.jpg
// module id = RFYq
// module chunks = 16